<template>
    <span>
        <a
            :href="conditionsUrl"
            target="_blank"
            class="text-primary-blue text-decoration-underline"
            @click.stop
            >{{ content.terms_and_conditions_1 }}</a
        >
        <template v-if="content.terms_and_conditions_2">
            <span
                class="text-primary-blue ms-1"
                >{{ content.terms_and_conditions_2 }}</span
            >
        </template>
        <template v-if="content.terms_and_conditions_3">
            <a
            :href="conditionsUrl"
            target="_blank"
            class="text-primary-blue text-decoration-underline"
            @click.stop
            >{{ content.terms_and_conditions_3 }}</a
        >
    </template>
    </span>
</template>


<script setup lang="ts">
// Imported copmuted
import conditionsUrl from "../../../computed/conditionsUrl"

const content = window.content
</script>